//-------------------------header-sticky-js-start--------------

    $(window).scroll(function(){
        if ($(this).scrollTop() > 90) {
            $('header').addClass('sticky-header');
        } else {
            $('header').removeClass('sticky-header');
        }

    });

//------------------------header-sticky-js-end------------------

//-------------------------change-logofor mobile and tablet-js-start--------------
  $(document).ready(function(){
         if ($(window).width() < 991) {
                $('header a.navbar-brand img').attr('src', 'https://cdn.shopify.com/s/files/1/0674/3873/9624/files/sitelogo_183c8edc-8c17-4a13-b68a-2bd13f7408b7.png?v=1727074372');
            } 
            else {
               $('header a.navbar-brand img').attr('src', 'https://cdn.shopify.com/s/files/1/0674/3873/9624/files/sit-logo.svg?v=1726834209');
            }
    });
//-------------------------change-logofor mobile and tablet-js-end--------------

//------------------------navbar-toggler-js-start------------------
        $(".navbar-toggler").click(function(){
    	    $(this).toggleClass('navbar-closed');
    	    $("html").toggleClass("myClass");
    	});        
//------------------------navbar-toggler-js-end------------------

//------------------------menu-dropdown-js-start------------------
        $(".Header .dropdown .drop-arrow").click(function(){
    	    $(this).parent(".Header .dropdown").toggleClass('show');
    	});
//------------------------menu-dropdown-js-end--------------------  

//------------------------dropdown-menu-js-start------------------
     $(".Header .dropdown-boxes .dropdown-heading").click(function(){
      $('.Header .dropdown-boxes .dropdown-heading').not(this).removeClass('active');
      $(this).toggleClass('active');
      $('.Header .dropdown-boxes').not($(this).parent('.Header .dropdown-boxes')).removeClass('show');
      $(this).parent('.Header .dropdown-boxes').toggleClass('show');
    });
//------------------------dropdown-menu-js-end--------------------


//------------------------owl-slider-js-start------------------
 
   $('.LogoSlider').owlCarousel({
        items:6,
        loop:true,
        margin:10,
        nav:false,
        // navText:['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
        dots:false,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
            0:{
                items:2
            },
            567:{
                items:3
            },
            767:{
                items:4
            },
            1200:{
                items:6
            }

        }

    });
   // $('.recipe_slider').owlCarousel({
   //      items:3,
   //      loop:true,
   //      margin:30,
   //      nav:true,
   //      navText:['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
   //      dots:true,
   //      dotsEach:true,
   //      responsive:{
   //          0:{
   //              items:1
   //          },
   //          567:{
   //              items:2
   //          },
   //          1000:{
   //              items:3
   //          }

   //      }

   //  });
  $('.join-slider').owlCarousel({
        items:1,
        loop:true,
        margin:0,
        nav:false,
        dots:false,
        autoplay: true,
        mouseDrag: false,
        autoplayTimeout: 2000,
        autoplaySpeed: 2000,
        animateOut: "fadeOut",
        animateIn: "fadeIn"
    });

//------------------------owl-slider-js-end--------------------

//-----------------------increase-decrease-button-js-start-----------------------
  function increaseValue() {
  let quantityInput = document.getElementById('number');
  let currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
}

function decreaseValue() {
  let quantityInput = document.getElementById('number');
  let currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
  }
}

//-----------------------increase-decrease-button-js-end-----------------------

document.addEventListener('DOMContentLoaded', () => {
    const quantitySection = document.getElementById('Quantity-Form-template--17320735211674__main'); // Quantity section

    // Function to hide quantity if Subscribe button is found
    const checkForSubscribeButton = () => {
        const subscribeNowButton = document.querySelector('.sealsubs-subscribe-now'); // Subscription button
        if (subscribeNowButton && quantitySection) {
            quantitySection.style.display = 'none';
        }
    };
 
    checkForSubscribeButton();
 
    const observer = new MutationObserver(() => checkForSubscribeButton());
    observer.observe(document.body, { childList: true, subtree: true });
});


gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".parallax-section").forEach(section => {
  let video = section.querySelector(".parallax-video");

  gsap.fromTo(
    video,
    { y: "0%" }, 
    { 
      y: "50%",  
      ease: "none",  
      scrollTrigger: {
        trigger: section,
        start: "top",
        end: "bottom",
        scrub: true, 
      }
    }
  );
});











  